var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    { staticClass: "px-3" },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "header-sticky" },
        [
          _c(
            "v-card",
            {
              staticClass: "w-100",
              attrs: {
                color: _vm.$vuetify.theme.dark ? "#2E2E2E" : "grey lighten-3",
                "min-width": "640",
                width: "100%",
                elevation: "0",
              },
            },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "start", "no-gutters": "" } },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "pr-2", attrs: { large: "" } },
                        [_vm._v("mdi-account-box-multiple-outline")]
                      ),
                      _c("h3", [_vm._v(_vm._s(_vm.$t("presencelist")))]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "px-8" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { justfiy: "space-around" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "center" } },
                                    [
                                      _c(
                                        "v-text-field",
                                        {
                                          staticClass: "mx-2",
                                          attrs: {
                                            label: _vm.$t("search"),
                                            placeholder:
                                              _vm.$t("searchHere") + "...",
                                            color: "primary",
                                            "hide-details": "",
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.anwesenheitsListsearch,
                                            callback: function ($$v) {
                                              _vm.anwesenheitsListsearch = $$v
                                            },
                                            expression:
                                              "anwesenheitsListsearch",
                                          },
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "append" },
                                            [
                                              _vm.anwesenheitsListsearch == ""
                                                ? _c("v-icon", [
                                                    _vm._v("mdi-magnify"),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "center" } },
                                    [
                                      _c("v-select", {
                                        staticClass: "mx-2",
                                        attrs: {
                                          items: _vm.teamList,
                                          color: "primary",
                                          value: _vm.$t("all"),
                                          disabled:
                                            _vm.formShow.includes(
                                              "dataTable"
                                            ) != true,
                                          required: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.filterAnwesenheitslist()
                                          },
                                        },
                                        model: {
                                          value: _vm.groupSearchSelect,
                                          callback: function ($$v) {
                                            _vm.groupSearchSelect = $$v
                                          },
                                          expression: "groupSearchSelect",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "center" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "mx-1",
                                        attrs: {
                                          label: _vm.$t(
                                            "showOnlyPresentEmployee"
                                          ),
                                          color: "primary",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.filterAnwesenheitslist()
                                          },
                                        },
                                        model: {
                                          value: _vm.showOnlyPresentMembers,
                                          callback: function ($$v) {
                                            _vm.showOnlyPresentMembers = $$v
                                          },
                                          expression: "showOnlyPresentMembers",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "pt-3",
                                      attrs: {
                                        justify: "center",
                                        "no-gutters": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "h3",
                                        {
                                          staticClass: "d-flex justify-center",
                                        },
                                        [_vm._v(_vm._s(_vm.$t("employees")))]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          staticClass: "mx-2 mt-1",
                                          attrs: { top: "", color: "green" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c("v-avatar", {
                                                        staticClass: "mx-2",
                                                        attrs: {
                                                          color: "green",
                                                          size: "12",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.presentEmployeeCounter
                                                        )
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c("span", {
                                            class: this.$vuetify.theme.dark
                                              ? ""
                                              : "textColor--text",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm
                                                  .$t("presentEmployeesTooltip")
                                                  .format(
                                                    _vm.usersInHouse,
                                                    _vm.usersInHomeOffice,
                                                    _vm.usersOut
                                                  )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          staticClass: "mx-2 mt-1",
                                          attrs: { top: "", color: "primary" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c("v-avatar", {
                                                        staticClass: "mx-2",
                                                        attrs: {
                                                          color: "red",
                                                          size: "12",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.absenceEmployeeCounter
                                                        )
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c("span", {
                                            class: this.$vuetify.theme.dark
                                              ? ""
                                              : "textColor--text",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.setAbsentHint()
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "presence-list-scroll", attrs: { tile: "" } },
        [
          _c(
            "v-card",
            {
              staticClass: "w-100",
              attrs: {
                color: _vm.$vuetify.theme.dark ? "#2E2E2E" : "grey lighten-3",
                "min-width": "640",
                width: "100%",
              },
            },
            [
              _c(
                "v-card-text",
                { staticClass: "px-8" },
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "end" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticStyle: { height: "30px" },
                          attrs: { justify: "end" },
                        },
                        [
                          _c("v-progress-circular", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.progressCircular,
                                expression: "progressCircular",
                              },
                            ],
                            attrs: {
                              color: "primary",
                              indeterminate: "",
                              size: "24",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.formShow.includes("dataTable") == true
                    ? _c("Cards", {
                        attrs: {
                          Employees: _vm.employees,
                          SearchVal: _vm.anwesenheitsListsearch,
                        },
                        on: { click: _vm.openEmployeeInfo },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.dialogLegende
        ? _c("Legend", {
            on: {
              close: function ($event) {
                _vm.dialogLegende = false
              },
            },
          })
        : _vm._e(),
      !_vm.dialogLegende
        ? _c(
            "div",
            { attrs: { id: "overflowButtons" } },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "", color: "primary" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  attrs: {
                                    id: "legendButton",
                                    color: "primary",
                                    fab: "",
                                    fixed: "",
                                    top: "",
                                    right: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogLegende = true
                                    },
                                  },
                                },
                                on
                              ),
                              [
                                _c(
                                  "v-icon",
                                  { staticStyle: { height: "unset" } },
                                  [_vm._v("mdi-table-of-contents")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1230205070
                  ),
                },
                [
                  _c("span", { staticStyle: { "align-items": "end" } }, [
                    _vm._v(_vm._s(_vm.$t("showLegend"))),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.ShowHistoryMonthDialog
        ? _c("HistoryMonthDialog", {
            attrs: { User: _vm.selectedUser },
            on: {
              close: function ($event) {
                _vm.ShowHistoryMonthDialog = false
              },
              OpenDailyHistory: _vm.OpenDailyHistory,
            },
          })
        : _vm._e(),
      _vm.ShowDailyHistoryDialog
        ? _c("DailyHistoryDialog", {
            attrs: { User: _vm.selectedUser, date: _vm.DailyHistoryDate },
            on: { close: _vm.dailyHistoryDialogClose },
          })
        : _vm._e(),
      _vm.showEmployeeInformationDialog
        ? _c("EmployeeInformation", {
            attrs: {
              user: _vm.selectedUser,
              profilePicture: _vm.profilePicture,
              status: _vm.status,
              workedHours: _vm.workedHours,
              pauseHours: _vm.pauseHours,
              balance: _vm.balance,
              pauseDebit: _vm.pauseDebit,
              holidayInfo: _vm.holidayInfo,
              showNotification: false,
              ownInfo:
                _vm.$store.getters["user/user"].SAPEmpId ===
                _vm.selectedUser.SAPEmpId,
              showHolidaysButton: false,
            },
            on: {
              closed: function ($event) {
                _vm.showEmployeeInformationDialog = false
              },
              showMonthlyHistoryClicked: _vm.HistoryMonthDialogOpen,
              showHistoryClicked: function ($event) {
                _vm.OpenDailyHistory(new Date().toISOString().substr(0, 10))
              },
              addVacationClicked: function ($event) {
                _vm.ShowAbsenceDialog = true
              },
            },
          })
        : _vm._e(),
      _vm.ShowAbsenceDialog
        ? _c("AbsenceDialog", {
            attrs: {
              CanSendAbsence: false,
              User: _vm.$store.getters["user/user"],
              IsVacation: true,
            },
            on: {
              close: function ($event) {
                _vm.ShowAbsenceDialog = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }